import { IS_SELF_HOSTED } from "./constants";

export const EVENTS_ROUTE = "/events";
export const EVENT_DETAILS = (UUID = ":uuid") => `${EVENTS_ROUTE}/${UUID}`;
export const SESSIONS_ROUTE = "/sessions";
export const SESSION_DETAILS = (UUID = ":uuid") => `${SESSIONS_ROUTE}/${UUID}`;
export const DASHBOARD_ROUTE = "/dashboard";
// Self-hosted ships without the dashboard, so users land on events there.
export const HOME_ROUTE = IS_SELF_HOSTED ? EVENTS_ROUTE : DASHBOARD_ROUTE;
export const CUSTOMERS_ROUTE = "/customers";
export const CUSTOMERS_DETAILS = (UUID = ":uuid") =>
	`${CUSTOMERS_ROUTE}/${UUID}`;
export const DEVICES_ROUTE = "/devices";
export const DEVICES_DETAILS = (UUID = ":uuid") => `${DEVICES_ROUTE}/${UUID}`;
export const LISTS_ROUTE = "/lists";
export const LISTS_DETAILS_ROUTE = (UUID = ":uuid") => `${LISTS_ROUTE}/${UUID}`;

export const ORGANIZATION_ROUTE = "/organization";
export const ACCOUNT_SETTINGS_ROUTE = `${ORGANIZATION_ROUTE}/account-settings`;
export const TEAM_MANAGEMENT_ROUTE = `${ORGANIZATION_ROUTE}/team-management`;

export const DEVELOPER_ROUTE = "/developer";
export const API_KEYS_ROUTE = `${DEVELOPER_ROUTE}/api-keys`;
export const WEBHOOKS_ROUTE = `${DEVELOPER_ROUTE}/webhooks`;

// Legacy paths kept for redirect-only routes (do not use for new links).
export const LEGACY_ACCOUNT_SETTINGS_ROUTE = "/account-settings";
export const LEGACY_TEAM_MANAGEMENT_ROUTE = "/team-management";
export const LEGACY_API_KEYS_ROUTE = "/api-keys";
export const LEGACY_WEBHOOKS_ROUTE = "/webhooks";

export const LOGS_ROUTE = `/logs`;
export const LOGS_EVENT_REPORTS_ROUTE = `${LOGS_ROUTE}/event-reports`;
export const LOGS_AUDIT_TRAIL_ROUTE = `${LOGS_ROUTE}/audit-trail`;

export const RULES_ROUTE = `/configuration`;
export const RULES_THRESHOLD_ROUTE = `${RULES_ROUTE}/event-threshold`;
export const RULES_EVENTS_ROUTE = `${RULES_ROUTE}/event-rules`;
export const RULES_MODEL_ROUTE = `${RULES_ROUTE}/event-model-config`;
export const CREATE_EVENT_RULE_ROUTE = `${RULES_EVENTS_ROUTE}/create`;
export const CUSTOM_FIELDS_ROUTE = `/custom-fields`;

export const NOT_FOUND_ROUTE = "/404";
